import React from 'react';

import Feed from 'components/Feed';

const App = () => <div style={{ '--gutter': '16px' } as React.CSSProperties}><Feed /></div>;

export default App;
